export interface ApiErrorResponse {
  error: string;
  level: ErrorLevel;
  code: string;
}

export enum ErrorLevel {
  ERROR = "ERROR",
  WARNING = "WARNING"
}
